import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChart2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconChart2"><Path fillRule="evenodd" clipRule="evenodd" d="M2.99999 4.5H1V3H23V4.5H21V18H13.4014L15.0401 20.458L13.792 21.2901L12 18.6021L10.208 21.2901L8.95993 20.458L10.5986 18H2.99999V4.5ZM12.75 7H11.25V14H12.75V7ZM16.5 9H15V14H16.5V9ZM9 11H7.5V14H9V11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChart2;
